import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description, image }) => (
  <Helmet>
    <title>{title ? `${title} | AI Writing Platforms` : "AI Writing Platforms"}</title>
    {description && <meta name="description" content={description} />}
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    {image && <meta property="og:image" content={image} />}
  </Helmet>
);
